import { FilterDropdown } from '@ui';
import { FilterKey, FilterResourceType } from '@features/components/CaseOverview/components/AssignedResources/types';
import { ResourceFilters, resourceTypeIs, tmdxUsers, txCenterContacts } from '../../config';
import { EmployeeRole } from '@/api/apis/resources';
import { CustomerRoleT } from '@/api/apis/customer';
import { getFilterTitle } from './utils';

type ResourceSubfilterProps = {
  filters: ResourceFilters;
  updateFilters: (filter: FilterResourceType[] | EmployeeRole[] | CustomerRoleT[], type: keyof ResourceFilters) => void;
};

export const ResourceSubfilter = ({ filters, updateFilters }: ResourceSubfilterProps) => {
  if (resourceTypeIs(FilterResourceType.TmdxContacts, filters))
    return (
      <FilterDropdown
        isFaded
        title={filters.tmdxUser.length ? getFilterTitle(tmdxUsers, filters.tmdxUser[0]) : 'User Role'}
        items={tmdxUsers}
        selectedKeys={filters.tmdxUser}
        mode="single"
        showCounter={false}
        onSelectedKeysChange={(values) => updateFilters(values, FilterKey.TmdxUser)}
      />
    );
  if (resourceTypeIs(FilterResourceType.TXContacts, filters)) {
    return (
      <FilterDropdown
        isFaded
        title={
          filters.txCenterContact.length ? getFilterTitle(txCenterContacts, filters.txCenterContact[0]) : 'User Role'
        }
        items={txCenterContacts}
        // @ts-expect-error Should be removed in LP when roles & permissions are separated
        selectedKeys={filters.txCenterContact}
        mode="single"
        showCounter={false}
        onSelectedKeysChange={(values) => updateFilters(values, FilterKey.TxCenterContact)}
      />
    );
  }
  return null;
};
